!function(window) {
function initSnake(){
   
    var canvas;
    var ctx;
    
   
    var snake;
    var snake_dir;
	var snake_next_dir;
    var snake_speed;
    
    var food = {x: 0, y: 0};
  
    var wall;
    
    var screen_snake;
    var screen_menu;
    var screen_gameover;
	var screen_gamestart;
    var button_newgame_menu;
    /////////////////////////////////////////////////////////////
    var activeDot = function(x, y){
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(x * 5, y * 5, 5, 5);
    } 
    /////////////////////////////////////////////////////////////
    var changeDir = function(key){
        if(key == 38 && snake_dir != 2){
            snake_next_dir = 0;
        }else{
        if (key == 39 && snake_dir != 3){
            snake_next_dir = 1;
        }else{
        if (key == 40 && snake_dir != 0){
            snake_next_dir = 2;
        }else{
        if(key == 37 && snake_dir != 1){
            snake_next_dir = 3;
        } } } }
    }
    /////////////////////////////////////////////////////////////
    var addFood = function(){
        food.x = Math.floor(Math.random() * ((canvas.width / 5) - 1));
        food.y = Math.floor(Math.random() * ((canvas.height / 5) - 1));
        for(var i = 0; i < snake.length; i++){
            if(checkBlock(food.x, food.y, snake[i].x, snake[i].y)){
                addFood();
            }
        }
    }
    //console.log(canvas.width);
    /////////////////////////////////////////////////////////////
    var checkBlock = function(x, y, _x, _y){
        return (x == _x && y == _y) ? true : false;
    }
    /////////////////////////////////////////////////////////////
    var mainLoop = function(){
            var _x = snake[0].x;
            var _y = snake[0].y;
			snake_dir = snake_next_dir;
            switch(snake_dir){
                case 0: _y--; break;
                case 1: _x++; break;
                case 2: _y++; break;
                case 3: _x--; break;
            }
            snake.pop();
            snake.unshift({x: _x, y: _y});
        // Wall
            if(wall == 1){
                if (snake[0].x < 0 || snake[0].x == canvas.width / 5 || snake[0].y < 0 || snake[0].y == canvas.height / 5){
                    showScreen(1);
                    return;
                }
            }else{
                for(var i = 0, x = snake.length; i < x; i++){
                    if(snake[i].x < 0){
                        snake[i].x = snake[i].x + (canvas.width / 5);
                    }
                    if(snake[i].x == canvas.width / 5){
                        snake[i].x = snake[i].x - (canvas.width / 5);
                    }
                    if(snake[i].y < 0){
                        snake[i].y = snake[i].y + (canvas.height / 5);
                    }
                    if(snake[i].y == canvas.height / 5){
                        snake[i].y = snake[i].y - (canvas.height / 5);
                    }
                }
            }
        // --------------------
        //death
            for(var i = 1; i < snake.length; i++){
                if (snake[0].x == snake[i].x && snake[0].y == snake[i].y){
                    showScreen(1);
                    return;
                }
            }
      // eat
            if(checkBlock(snake[0].x, snake[0].y, food.x, food.y)){
                snake[snake.length] = {x: snake[0].x, y: snake[0].y};
                addFood();
                activeDot(food.x, food.y);
            }
            ctx.beginPath();
            ctx.fillStyle = "#000000";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            for(var i = 0; i < snake.length; i++){
                activeDot(snake[i].x, snake[i].y);
            }
            activeDot(food.x, food.y);
            setTimeout(mainLoop, snake_speed);
    }
    /////////////////////////////////////////////////////////////
    var newGame = function(){
        showScreen(0);
        screen_snake.focus();
        snake = [];
        for(var i = 4; i >= 0; i--){
            snake.push({x: i, y: 15});
        }
        snake_next_dir = 1;
        addFood();
        canvas.onkeydown = function(evt) {
            evt = evt || window.event;
            changeDir(evt.keyCode);
        }
        mainLoop();
    }
    /////////////////////////////////////////////////////////////
    var setSnakeSpeed = function(speed_value){
        snake_speed = speed_value;
    }
    /////////////////////////////////////////////////////////////
    var setWall = function(wall_value){
        wall = wall_value;
        if(wall == 0){screen_snake.style.borderColor = "#606060";}
        if(wall == 1){screen_snake.style.borderColor = "#FFFFFF";}
    }
    /////////////////////////////////////////////////////////////
    // 0 for the game
    // 1 for the game over screen
    var showScreen = function(screen_opt){
        switch(screen_opt){
            case 0:  screen_snake.style.display = "block";
                     screen_menu.style.display = "none";
                     screen_gameover.style.display = "none";
					 screen_gamestart.style.display = "none";
                     break;
            case 1: screen_snake.style.display = "none";
                    screen_menu.style.display = "none";
                    screen_gameover.style.display = "block";
					screen_gamestart.style.display = "none";
                    break;
        }
    }
    /////////////////////////////////////////////////////////////
    window.onload = function(){
        canvas = document.getElementById("snake");
        ctx = canvas.getContext("2d");
		// Screens
		screen_snake = document.getElementById("snake");
		screen_menu = document.getElementById("menu");
		screen_gameover = document.getElementById("gameover");
		screen_gamestart = screen_menu;

        setSnakeSpeed(150);
        setWall(1);
        showScreen("menu");


        document.onkeydown = function(evt){
            if([32, 37, 38, 39, 40].indexOf(evt.keyCode) > -1) {
                evt.preventDefault();
            }

            if(screen_gameover.style.display == "block"){
                evt = evt || window.event;
                if(evt.keyCode == 83){
                    newGame();
                }
            }
			if(screen_gamestart.style.display == "block"){
				if(evt.keyCode == 83){
					newGame();
				}
			}
        }
    }
}

module.exports = {start : initSnake}
    
window.initSnake = initSnake;
}(window);